<template lang="html">
  <div id="services-page">

    <section class="container oversized-container main-section">
      <div class="row align-items-center">
        <div class="col-lg-12 col-info">
          <div class="col-s-title">
            <h2 class="title text-center txt-blue">Servicios</h2>
          </div>
        </div>

        <!-- <div class="col-lg-5 col-image">
          <img src="public/images/pages/fonacot/logo-fonacot.jpg">
        </div> -->

        <!-- <div class="col-lg-7 col-info">
          <div class="col-s-title">
            <h2 class="title txt-blue">Servicios</h2>
          </div>

          <p>
             Hoy en día el Instituto FONACOT es una organización que fomenta el desarrollo integral de los trabajadores y el crecimiento de su patrimonio familiar, promoviendo el acceso al mejor crédito del mercado y otros servicios financieros, para la obtención de bienes y servicios de alta calidad a precios competitivos.
          </p>

          <br />
          <p>
             El crédito FONACOT constituye un importante apoyo para elevar el nivel de vida de los trabajadores, ya que:
          </p>

          <ul>
            <li>Ofrece la mejor tasa de interés.</li>
            <li>No requiere aval, ni fiador.</li>
            <li>Se puede ejercer en miles de puntos de venta en todo el país.</li>
            <li>Es útil para financiar las necesidades de los trabajadores durante todo su ciclo de vida.</li>
            <li>La oferta de productos y servicios es de alta calidad y a precio competitivo.</li>
            <li>Ayuda a construir un historial crediticio del trabajador.</li>
          </ul>
        </div> -->
      </div>

      <!-- <div class="row col-info">
        <div class="col-12 mt-4 mt-lg-0">
          <h4 class="mb-1 f-w-600 txt-red">Requisitos</h4>
        </div>

        <div class="col-lg-6 mb-3">
          <ol>
            <li>Antigüedad de un año en la empresa afiliada a fonacot.</li>
            <li>Llenado de solicitud.</li>
            <li>Último recibo de nómina si tu pago es semanal, si es quincenal los dos últimos y si eres comisionista los tres últimos meses de recibo de nómina.</li>
            <li>Comprobante de domicilio a su nombre o anexar estado de cuenta del banco o afore a nombre del solicitante con el mismo domicilio del comprobante que presente.</li>
            <li>Identificación con fotografía (credencial de elector, cartilla militar no mayor de 4 años o cedula profesional no mayor a 10 años).</li>
            <li>Firma de contrato proporcionado por Maderas y Ferreterías Durán.</li>
            <li>Dos referencias personales con teléfono de casa, la primera de un familiar de cualquier parte de la república y la segunda un conocido que no labore en el mismo lugar.</li>
          </ol>
        </div>

        <div class="col-lg-6">
          <p class="mb-2 f-w-600" style="line-height: 1.15;">Si es tu segundo crédito fonacot, ya no es necesario el llenado de la solicitud, solo los siguientes requisitos:</p>

          <ol>
            <li>Último recibo de nómina si el pago es semanal, los dos últimos si el pago es quincenal o los tres últimos meses si eres comisionista.</li>
            <li>Comprobante de domicilio a tu nombre o anexar estado de cuenta del banco o afore con el domicilio igual al comprobante que vas a presentar. </li>
            <li>Identificación con fotografía (credencial de elector, cartilla militar no mayor a 4 años, cédula profesional no mayor a 10 años). </li>
            <li>Firma del contrato proporcionado por la ferretería y llenado de dos referencias personales con teléfono de casa, la primera de un familiar de cualquier parte de la república y la segunda un conocido que no labore en el mismo lugar.</li>
          </ol>

          <br />
          <p>Los requisitos puede cambiar sin previo aviso: www.fonacot.gob.mx</p>
        </div>
      </div> -->
    </section>

    <section class="container oversized-container extra-section">
      <div class="row justify-content-between">
        <div class="col-6 col-md-4 col-box" data-aos="fade-up" data-aos-delay="50">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/services/service-1.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Servicio a domicilio</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-4 col-box" data-aos="fade-up" data-aos-delay="100">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/services/service-2.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Pick up en tienda</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-4 col-box" data-aos="fade-up" data-aos-delay="150">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/services/service-3.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Atención a proyectos</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-4 col-box" data-aos="fade-up" data-aos-delay="200">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/services/service-4.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Pedidos especiales</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-4 col-box" data-aos="fade-up">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/services/service-5.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Atención a subdistribuidores</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
      image: ''
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/nosotros')).then((response)=>{
        this.content = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
